import { createAction, props } from "@ngrx/store";
import { AppErrorState } from "./error.state";

export const setError = createAction(
	"[ERROR] RAISE_APP_ERROR",
	props<{ error: AppErrorState }>()
);
export const resetError = createAction("[ERROR] RESET_APP_ERROR");
